import { BaseType } from '../../../models/base/base-type';
import { BeneficiaryRelationshipTypeEnum } from '../enums/beneficiary-relationship-type-enum';

export class BeneficiaryRelationshipToMemberType extends BaseType {
  public declare id: BeneficiaryRelationshipTypeEnum;
}
